import { actions } from '../actions';
import { reduxSwitch } from '../../../tools';
import { ods } from '../../../../api';

const defaultState = {
	preview: null,
	list: null,
	uri: null,
	parameters: null,
	hasMore: null,
	pending: false,
	error: null,
	at: null,
	// export
	exporting: false,
	progress: null, // { percent, done, total }
	csv: null,
};

const updateAnchor = (parameters, trips) => {
	if (trips) parameters.anchor = new ods.assets.CommuteHistoryAnchor().anchorOn(trips);
	return parameters;
}

function apiReducer(state, action) {
	let _state;
	switch (action.type) {
		case actions.commute.request.type:
			if (action.clear) {
				_state = { ...defaultState };
			} else {
				_state = {...state};
			}
			return {
				..._state,
				uri: action.uri,
				parameters: action.parameters,
				pending: true,
				error: null,
				at: action.clear ? new Date() : _state.at
			};
		case actions.commute.success.type:
			const hasMore = action.trips ? action.trips.length > 0 : false;
			const list = state.list ? (action.trips ? state.list.concat(action.trips) : state.list) : (action.trips ? [...action.trips] : []);
			_state = {...state};
			return {
				..._state,
				list,
				parameters: updateAnchor(state.parameters, action.trips),
				hasMore,
				pending: false
			};
		case actions.commute.fail.type:
			return {
				...state,
				pending: false,
				error: action.errorMessage
			};
		case actions.commute.cancel.type:
			return {
				...state,
				pending: false
			};
		default:
			return state;
	}
}

function exportReducer(state, action) {
	switch (action.type) {
		case actions.commute.export.type:
			return {
				...state,
				exporting: true,
				progress: null,
				csv: null
			}
		case actions.commute.exportProgress.type:
			return {
				...state,
				progress: {
					percent: action.progress,
					done: action.count,
					total: action.total
				}
			}
		case actions.commute.exportDone.type:
			return {
				...state,
				parameters: state.parameters,
				exporting: false,
				csv: action.csv
			}
		case actions.commute.exportClear.type:
			return {
				...state,
				csv: null
			}
		default:
			return state;
	}

}

const reducer = reduxSwitch([apiReducer, exportReducer], defaultState);

export { reducer };
